import type { RowData } from '../../types/RowData';
import { selectRows } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useGridRows() {
  return useEagGridSelector(selectRows);
}